// Filename - App.js

import "./App.css";
import {
    BrowserRouter as Router,
    Routes,
    Route
} from "react-router-dom";
import styled from "styled-components";
import React, { useState,useEffect} from "react";
import axios from 'axios';

// Import Amplify configuration
import './config/amplifyConfig';
import ProtectedRoute from './components/auth/ProtectedRoute';
import { authService } from './services/authService';
import { notificationService } from './services/notificationService';
import emailService from './services/emailService';

import NasWideSummary from "./screens/NasWideSummary";
import NavLayout from "./screens/NavLayout";

import AirportSummary from "./screens/metrics/AirportSummary";
import Encroachments from "./screens/metrics/Encroachments";
import AirGroundInteractions from "./screens/metrics/AirGroundInteractions";
import CenterlineDeviations from "./screens/metrics/CenterlineDeviations";
import TurbulenceCounts from "./screens/metrics/TurbulenceCounts";
import FlightPlanChangeCounts from "./screens/metrics/FlightPlanChangeCounts";
import GoArounds from "./screens/metrics/GoArounds";
import AirportSelector from "./screens/metrics/AirportSelector";
import VectoringCounts from "./screens/metrics/VectoringCounts"

import HistoricData from "./screens/analytics/HistoricData";
import ExploratoryAnalysis from "./screens/analytics/ExploratoryAnalysis";
import ReportGenerator from "./screens/analytics/ReportGenerator";
import WeeklyMonitor from "./screens/analytics/WeeklyMonitor";
import {getBackendHost} from "./config/EnvData"
const SUMMARY_METRIC_NAME = 'airport-summary'
const SUMMARY_METRIC_INDEX = 1
const METRIC_LOOKBACK_HORIZON_DAYS = 2
const enabledAirports = {'air-ground-interactions':['ATL','JFK']}
// const MasterLayout = styled.div`
    // display:flex;
// `;
// <Route path="/" element={<NavLayout/>}>
                    // <Route index element={<NasWideSummary/>}
                    // />
                // </Route>
const BACKEND_API_PREFIX = getBackendHost()
function App() {
    const [sidebar, setSidebar] = useState(true);
    const [currentPageTitle, setPageTitle] = useState('');
    const [airportDataList,setAirportDataList] = useState([]);
    const [activeMetric, setActiveMetric] = useState('')
    const [activeAirport, setActiveAirport] = useState('')
    const [selectedMetricIndex, setMetricSelectedIndex] = useState(null)
    const [notificationData,setNotificationData] = useState([])
    const [currentUser, setCurrentUser] = useState(null)
    const [coloringThresholds,setColoringThresholds] = useState({'RED':'95Perc','ORANGE':'80Perc'})
    // const [pendingRequests, setPendingRequests] = useState([])
    const showSidebar = () => setSidebar(!sidebar);
    
    
    const setActiveMetricCache=(metricVal)=>{
        setActiveMetric(metricVal)
        sessionStorage.setItem('activeMetric',metricVal)
    };
    
    const setActiveAirportCache=(airportVal)=>{
        setActiveAirport(airportVal)
        sessionStorage.setItem('activeAirport',airportVal)
    };
    
    const setPageTitleCache=(titleVal)=>{
        setPageTitle(titleVal)
        // sessionStorage.setItem('pageTitle',titleVal)
    };
    
    const setMetricSelectedIndexCache=(indexVal)=>{
        setMetricSelectedIndex(indexVal)
        localStorage.setItem('selectedMetricIndex',indexVal)
    };
    
    const setNotificationDataCache=(notificationVal)=>{
        setNotificationData(notificationVal)
        // Keep localStorage as fallback for guest users
        if (!currentUser?.attributes?.email) {
            localStorage.setItem('notificationData',JSON.stringify(notificationVal))
        }
    };

    // Load notifications from backend for authenticated users
    const loadUserNotifications = async () => {
        if (currentUser?.attributes?.email) {
            const result = await notificationService.getUserNotifications(currentUser.attributes.email);
            if (result.success) {
                setNotificationData(result.notifications);
                
                // Migrate any existing localStorage notifications
                const localNotifications = JSON.parse(localStorage.getItem('notificationData') || '[]');
                if (localNotifications.length > 0) {
                    await notificationService.migrateLocalStorageNotifications(
                        currentUser.attributes.email, 
                        localNotifications
                    );
                    // Clear localStorage after migration
                    localStorage.removeItem('notificationData');
                    // Reload to get migrated notifications
                    const updatedResult = await notificationService.getUserNotifications(currentUser.attributes.email);
                    if (updatedResult.success) {
                        setNotificationData(updatedResult.notifications);
                    }
                }
            }
        }
    };

    // const checkJobStatus = async () => {
        // if(pendingRequests.length === 0) return;
        
        // console.log('Checking status for pending requests...');
        
        // for(const reqData of pendingRequests){
            // try {
                // console.log('Polling request:', reqData.requestId);
                // const statusResponse = await axios.get(`${BACKEND_API_PREFIX}/api/get-job-status/`, {
                    // params: { requestId: reqData.requestId }
                // });
                
                // console.log('Status response:', statusResponse.data);
                // const jobStatus = statusResponse.data;
                
                // if (jobStatus.status === 'completed') {
                    // console.log('Job completed:', reqData.requestId);
                    // // Remove from pending requests
                    // setPendingRequests(prev => prev.filter(req => req.requestId !== reqData.requestId));
                // }
                // // If still processing, continue polling
                
            // } catch (error) {
                // console.error('Error polling job status:', error);
            // }
        // }
    // };

    // useEffect(() => {
        // if(pendingRequests.length === 0) return;
        // console.log("Polling setup")
        // const interval = setInterval(() => {
            // checkJobStatus();
        // }, 1000); // Poll every second
        
        // return () => clearInterval(interval);
    // }, [pendingRequests]);
    
    useEffect(() => {
        // Read from sessionStorage on component mount
        if(sessionStorage.getItem('activeAirport')){
            console.log("Found activeAirport")
            setActiveAirport(sessionStorage.getItem('activeAirport'))
        }
        if(sessionStorage.getItem('activeMetric')){
            console.log("Found activeMetric")
            console.log(sessionStorage.getItem('activeMetric'))
            setActiveMetric(sessionStorage.getItem('activeMetric'))
        }
        if(sessionStorage.getItem('pageTitle')){
            console.log("Found pagetitle")
            // setPageTitle(sessionStorage.getItem('pageTitle'))
        }
        if(sessionStorage.getItem('selectedMetricIndex')){
            console.log("Found selectedMetricIndex")
            console.log(sessionStorage.getItem('selectedMetricIndex'))
            setMetricSelectedIndex(sessionStorage.getItem('selectedMetricIndex'))
        }
        // For guest users, load from localStorage
        if(!currentUser?.attributes?.email && localStorage.getItem('notificationData')){
            console.log("Found notification data in localStorage (guest user)")
            setNotificationData(JSON.parse(localStorage.getItem('notificationData')))
        }
        
      }, []);
    
    // No warm-up POST before this: /api/get-swans-airports/ refreshes its own cache when stale
    // (views.loadActiveAirportData). The POST used to live in its own useEffect, unchained from
    // this GET, so the two raced and the first load after an airport was added served the
    // previous list.
    useEffect(() => {
        axios.get(BACKEND_API_PREFIX+'/api/get-swans-airports/')
          .then(response => {
            var airportData = response.data.message
            setAirportDataList(airportData);
          })
          .catch(error => {
            console.log(error);
          });
      }, []);


    // Function to update user in App state (can be called from child components)
    const updateCurrentUser = async () => {
        try {
            const result = await authService.getCurrentUserWithAttributes();
            if (result.success) {
                setCurrentUser(result.user);
                console.log('User data refreshed:', result.user);
                // Load notifications for the authenticated user
                await loadUserNotifications();
            }
        } catch (error) {
            console.error('Failed to update current user:', error);
        }
    };

    // // Load notifications when user changes
    // useEffect(() => {
        // if (currentUser?.attributes?.email) {
            // loadUserNotifications();
            // // Check for pending jobs and add to pendingRequests
            // loadUserPendingJobs();
        // } else {
            // // Reset pending requests when user logs out
            // setPendingRequests([]);
        // }
    // }, [currentUser?.attributes?.email]);

    // // Load pending jobs for user and add to pendingRequests
    // const loadUserPendingJobs = async () => {
        // if (currentUser?.attributes?.email) {
            // const result = await notificationService.getUserPendingJobs(currentUser.attributes.email);
            // if (result.success && result.pendingJobs.length > 0) {
                // console.log(`Found ${result.pendingJobs.length} pending jobs for user`);
                // console.log(result.pendingJobs)
                // setPendingRequests(result.pendingJobs);
            // }
        // }
    // };

    // Live notifications via Server-Sent Events (replaces the old 1s poll).
    // - initial REST load paints immediately and runs the localStorage migration
    // - SSE `snapshot` reconciles the full list on (re)connect; `notification`
    //   events append new items in real time
    // - a visibility-change refetch is the only fallback, covering the rare window
    //   where an event is missed while the tab is hidden / mid-reconnect
    useEffect(() => {
        const email = currentUser?.attributes?.email;
        if (!email) return;

        loadUserNotifications();

        const stream = notificationService.openNotificationStream(email, {
            onSnapshot: (notifications) => {
                setNotificationData(notifications);
            },
            onNotification: (notification) => {
                setNotificationData((prev) => {
                    if (prev.some((n) => n.id === notification.id)) return prev;
                    return [notification, ...prev];
                });
            },
        });

        const refetchOnVisible = () => {
            if (document.visibilityState === 'visible') {
                loadUserNotifications();
            }
        };
        document.addEventListener('visibilitychange', refetchOnVisible);

        return () => {
            if (stream) stream.close();
            document.removeEventListener('visibilitychange', refetchOnVisible);
        };
    }, [currentUser?.attributes?.email]);

    // useEffect(() => {
    //     axios.post('http://localhost:8000/api/download-all-metric-data/')
    //     .then(response => {
    //         console.log("Metric Data",response);
    //     })
    //     .catch(error =>{
    //         console.log(error);
    //     });
    // },[]);

    // useEffect(() => {
    //     // Anything in here is fired on component mount.
    //     return () => {
    //         // Anything in here is fired on component unmount.
    //     }
    // }, [])

    // const AirportSelectorElement = <AirportSelector airportDataList={airportDataList}/>;
    return (
        <>
        <Router>
            <Routes>
                {/* Default route - Show authentication form */}
                <Route path="/" element={
                    <ProtectedRoute user={currentUser} setUser={setCurrentUser}>
                        <NavLayout  sidebar={sidebar} showSidebar={showSidebar} pageTitle={currentPageTitle} airportDataList={airportDataList}
                                    setActiveMetric={setActiveMetricCache} setActiveAirport={setActiveAirportCache} 
                                    enabledAirports={enabledAirports} activeMetric={activeMetric} activeAirport={activeAirport}
                                    summaryMetricIndex={SUMMARY_METRIC_INDEX} summaryMetricName={SUMMARY_METRIC_NAME}
                                    setMetricSelectedIndex={setMetricSelectedIndexCache} selectedMetricIndex={selectedMetricIndex}
                                    notificationData={notificationData} setNotificationData={setNotificationDataCache}
                                    backendApiPrefix={BACKEND_API_PREFIX}
                                    currentUser={currentUser}
                                    setColoringThresholds={setColoringThresholds}
                        >
                            <NasWideSummary setTitle={setPageTitleCache} pageTitle={currentPageTitle}
                                            airportDataList={airportDataList} 
                                            setMetricSelectedIndex={setMetricSelectedIndexCache}
                                            summaryMetricIndex={SUMMARY_METRIC_INDEX}
                                            setActiveAirport={setActiveAirportCache}
                                            setActiveMetric={setActiveMetricCache}
                                            metricLookBackHorizonDays={METRIC_LOOKBACK_HORIZON_DAYS}
                                            coloringThresholds={coloringThresholds}
                                            backendApiPrefix={BACKEND_API_PREFIX}/>
                        </NavLayout>
                    </ProtectedRoute>
                } />
                
                {/* Guest routes - No authentication required */}
                <Route path="/guest"
                       element={
                           <NavLayout  sidebar={sidebar} showSidebar={showSidebar} pageTitle={currentPageTitle} airportDataList={airportDataList}
                                       setActiveMetric={setActiveMetricCache} setActiveAirport={setActiveAirportCache} 
                                       enabledAirports={enabledAirports} activeMetric={activeMetric} activeAirport={activeAirport}
                                       summaryMetricIndex={SUMMARY_METRIC_INDEX} summaryMetricName={SUMMARY_METRIC_NAME}
                                       setMetricSelectedIndex={setMetricSelectedIndexCache} selectedMetricIndex={selectedMetricIndex}
                                       notificationData={notificationData} setNotificationData={setNotificationDataCache}
                                       backendApiPrefix={BACKEND_API_PREFIX}
                                       currentUser={currentUser}
                                       setColoringThresholds={setColoringThresholds}
                           >
                               <NasWideSummary setTitle={setPageTitleCache} pageTitle={currentPageTitle}
                                               airportDataList={airportDataList} 
                                               setMetricSelectedIndex={setMetricSelectedIndexCache}
                                               summaryMetricIndex={SUMMARY_METRIC_INDEX}
                                               setActiveAirport={setActiveAirportCache}
                                               setActiveMetric={setActiveMetricCache}
                                               coloringThresholds={coloringThresholds}
                                               metricLookBackHorizonDays={METRIC_LOOKBACK_HORIZON_DAYS}
                                               backendApiPrefix={BACKEND_API_PREFIX}/>
                           </NavLayout>
                       }
                />
                
                {/* Airport Summary routes - Accessible to guests */}
                <Route path="/metrics/airport-summary"
                       element={
                           <NavLayout  sidebar={sidebar} showSidebar={showSidebar} pageTitle={currentPageTitle} airportDataList={airportDataList}
                                       setActiveMetric={setActiveMetricCache} setActiveAirport={setActiveAirportCache} 
                                       enabledAirports={enabledAirports} activeMetric={activeMetric} activeAirport={activeAirport}
                                       summaryMetricIndex={SUMMARY_METRIC_INDEX} summaryMetricName={SUMMARY_METRIC_NAME}
                                       setMetricSelectedIndex={setMetricSelectedIndexCache} selectedMetricIndex={selectedMetricIndex}
                                       notificationData={notificationData} setNotificationData={setNotificationDataCache}
                                       backendApiPrefix={BACKEND_API_PREFIX}
                                       currentUser={currentUser}
                                       setColoringThresholds={setColoringThresholds}
                           >
                               <AirportSelector 
                                   setTitle={setPageTitleCache} pageTitle={currentPageTitle}
                                   setActiveAirport={setActiveAirportCache}
                                   setActiveMetric={setActiveMetricCache}
                                   airportDataList={airportDataList} 
                                   enabledAirports={enabledAirports}
                                   backendApiPrefix={BACKEND_API_PREFIX}
                                   activeMetric="airport-summary"/>
                           </NavLayout>
                       }
                />
                <Route path="/metrics/airport-summary/:airport"
                       element={
                           <NavLayout  sidebar={sidebar} showSidebar={showSidebar} pageTitle={currentPageTitle} airportDataList={airportDataList}
                                       setActiveMetric={setActiveMetricCache} setActiveAirport={setActiveAirportCache} 
                                       enabledAirports={enabledAirports} activeMetric={activeMetric} activeAirport={activeAirport}
                                       summaryMetricIndex={SUMMARY_METRIC_INDEX} summaryMetricName={SUMMARY_METRIC_NAME}
                                       setMetricSelectedIndex={setMetricSelectedIndexCache} selectedMetricIndex={selectedMetricIndex}
                                       notificationData={notificationData} setNotificationData={setNotificationDataCache}
                                       backendApiPrefix={BACKEND_API_PREFIX}
                                       currentUser={currentUser}
                                       setColoringThresholds={setColoringThresholds}
                           >
                               <AirportSummary setTitle={setPageTitleCache} pageTitle={currentPageTitle} 
                                               key={activeAirport} metricLookBackHorizonDays={METRIC_LOOKBACK_HORIZON_DAYS}
                                               backendApiPrefix={BACKEND_API_PREFIX}/>
                           </NavLayout>
                       }
                />
                
                {/* Protected routes - Authentication required */}
                <Route path="/*" element={
                    <ProtectedRoute user={currentUser} setUser={setCurrentUser}>
                        <NavLayout  sidebar={sidebar} showSidebar={showSidebar} pageTitle={currentPageTitle} airportDataList={airportDataList}
                                    setActiveMetric={setActiveMetricCache} setActiveAirport={setActiveAirportCache} 
                                    enabledAirports={enabledAirports} activeMetric={activeMetric} activeAirport={activeAirport}
                                    summaryMetricIndex={SUMMARY_METRIC_INDEX} summaryMetricName={SUMMARY_METRIC_NAME}
                                    setMetricSelectedIndex={setMetricSelectedIndexCache} selectedMetricIndex={selectedMetricIndex}
                                    notificationData={notificationData} setNotificationData={setNotificationDataCache}
                                    backendApiPrefix={BACKEND_API_PREFIX}
                                    currentUser={currentUser}
                                    setColoringThresholds={setColoringThresholds} 
                        >
                            <Routes>
                                {['encroachments','air-ground-interactions',
                                    'centerline-deviations','go-arounds','turbulence-counts','flight-plan-changes','workload-metrics'].map((path,index) =>
                                                                            <Route path={'/metrics/'+path} 
                                                                                   element={<AirportSelector 
                                                                                                    setTitle={setPageTitleCache} pageTitle={currentPageTitle}
                                                                                                    setActiveAirport={setActiveAirportCache}
                                                                                                    setActiveMetric={setActiveMetricCache}
                                                                                                    airportDataList={airportDataList} 
                                                                                                    enabledAirports={enabledAirports}
                                                                                                    backendApiPrefix={BACKEND_API_PREFIX}
                                                                                                    activeMetric={path}/>} 
                                                                                   key={index} />)}
                                <Route
                                    path="/metrics/encroachments/:airport"
                                    element={<Encroachments setTitle={setPageTitleCache} key={activeAirport} pageTitle={currentPageTitle} 
                                                metricLookBackHorizonDays={METRIC_LOOKBACK_HORIZON_DAYS}
                                                backendApiPrefix={BACKEND_API_PREFIX}/>}
                                />
                                <Route
                                    path="/metrics/air-ground-interactions/:airport"
                                    element={<AirGroundInteractions setTitle={setPageTitleCache} key={activeAirport} pageTitle={currentPageTitle} 
                                            metricLookBackHorizonDays={METRIC_LOOKBACK_HORIZON_DAYS} backendApiPrefix={BACKEND_API_PREFIX}/>}
                                />
                                <Route
                                    path="/metrics/centerline-deviations/:airport"
                                    element={<CenterlineDeviations setTitle={setPageTitleCache} key={activeAirport} pageTitle={currentPageTitle} 
                                                metricLookBackHorizonDays={METRIC_LOOKBACK_HORIZON_DAYS} backendApiPrefix={BACKEND_API_PREFIX}/>}
                                />
                                <Route
                                    path="/metrics/go-arounds/:airport"
                                    element={<GoArounds setTitle={setPageTitleCache} key={activeAirport} pageTitle={currentPageTitle} 
                                                metricLookBackHorizonDays={METRIC_LOOKBACK_HORIZON_DAYS} backendApiPrefix={BACKEND_API_PREFIX}/>}
                                />
                                <Route
                                    path="/metrics/turbulence-counts/:airport"
                                    element={<TurbulenceCounts setTitle={setPageTitleCache} key={activeAirport} pageTitle={currentPageTitle} 
                                                metricLookBackHorizonDays={METRIC_LOOKBACK_HORIZON_DAYS} backendApiPrefix={BACKEND_API_PREFIX}/>}
                                />
                                <Route
                                    path="/metrics/flight-plan-changes/:airport"
                                    element={<FlightPlanChangeCounts setTitle={setPageTitleCache} key={activeAirport} pageTitle={currentPageTitle}
                                                metricLookBackHorizonDays={METRIC_LOOKBACK_HORIZON_DAYS} backendApiPrefix={BACKEND_API_PREFIX}/>}
                                />
                                <Route
                                    path="/metrics/workload-metrics/:airport"
                                    element={<VectoringCounts setTitle={setPageTitleCache} key={activeAirport} pageTitle={currentPageTitle} 
                                            metricLookBackHorizonDays={METRIC_LOOKBACK_HORIZON_DAYS} backendApiPrefix={BACKEND_API_PREFIX}/>}
                                />
                                <Route
                                    path="/analytics/historic-data"
                                    element={<HistoricData setTitle={setPageTitleCache} pageTitle={currentPageTitle} airportDataList={airportDataList} 
                                                notificationData={notificationData}
                                                activeAirport={activeAirport}
                                                backendApiPrefix={BACKEND_API_PREFIX}/>}
                                />
                                <Route
                                    path="/analytics/exploratory-analysis"
                                    element={<ExploratoryAnalysis setTitle={setPageTitleCache} pageTitle={currentPageTitle}
                                                backendApiPrefix={BACKEND_API_PREFIX}/>}
                                />
                                <Route
                                    path="/analytics/report-generator"
                                    element={<ReportGenerator setTitle={setPageTitleCache} pageTitle={currentPageTitle}
                                            backendApiPrefix={BACKEND_API_PREFIX}/>}
                                />
                                <Route
                                    path="/analytics/weekly-monitor"
                                    element={<WeeklyMonitor setTitle={setPageTitleCache} pageTitle={currentPageTitle} backendApiPrefix={BACKEND_API_PREFIX}/>}
                                />  
                            </Routes>
                        </NavLayout>
                    </ProtectedRoute>
                } />
            </Routes>
        </Router>
        </>
    );
}

export default App;
